import Drawable from './Drawable.js';
import { c } from '../setup.js';

export default class Boundary extends Drawable {
    static width = 16;
    static height = 16;

    serialize() {
        console.log(`Serializing ${this.constructor.name}`);
        return {
            position: this.position,
            _canInteract: this._canInteract,
        };
    }

    static deserialize(data) {
        return new Boundary({ position: data.position });
    }

    constructor({ position, OSM, GUI }) {
        super();
        this.width = Boundary.width;
        this.height = Boundary.height;
        this.xModifier = 0;
        this.yModifier = 0;
        this.OSM = OSM;
        this.GUI = GUI;
        this.position = position;
        this._canInteract = false;
    }

    canInteract() {
        return this._canInteract;
    }

    draw() {
        c.fillStyle = 'rgba(255, 0, 0, 1)';
        // if (this.OSM.player.position.z === this.position.z) {
        //     c.fillRect(
        //         this.position.x + this.xModifier,
        //         this.position.y + this.yModifier,
        //         this.width,
        //         this.height
        //     );
        // }
        c.fillStyle = 'black';

        // c.fillText(`(${this.position.x},${this.position.y})`, this.effectiveX(), this.effectiveY())
        // c.fillText(`(${this.effectiveX()},${this.effectiveY()})`, this.effectiveX(), this.effectiveY())
    }

    interact() {
        // Implement
    }
}
